import FeedItem from 'js/components/FeedItem/FeedItem'
import FeedItemContent from 'js/components/FeedItem/FeedItemContent'
import FeedItemFooter from 'js/components/FeedItem/FeedItemFooter'
import FeedItemImage from 'js/components/FeedItem/FeedItemImage'

type Props = {
    entity: any
    hideGroup?: boolean
    hideSubtype?: boolean
    hideExcerpt?: boolean
    hideComments?: boolean
    hideLikes?: boolean
    excerptMaxLines?: number
    'data-feed'?: any
}

const RelatedSiteResultCard = ({
    entity,
    hideGroup,
    hideSubtype,
    hideExcerpt,
    hideComments,
    hideLikes,
    excerptMaxLines,
    'data-feed': dataFeed,
}: Props) => {
    return (
        <FeedItem data-feed={dataFeed}>
            {/* @ts-expect-error - FeedItemContent is not typed */}
            <FeedItemContent
                entity={entity}
                hideGroup={hideGroup}
                hideSubtype={hideSubtype}
                hideExcerpt={hideExcerpt}
                excerptMaxLines={excerptMaxLines}
            />
            {/* @ts-expect-error - FeedItemFooter is not typed */}
            <FeedItemFooter
                entity={entity}
                hideComments={hideComments}
                hideLikes={hideLikes}
            />
            <FeedItemImage entity={entity} />
        </FeedItem>
    )
}

export default RelatedSiteResultCard
